import { EventBus, EVENTS } from '@/services/event-bus'
import dynamicYieldClient from '@/services/dynamic-yield-client'

export function setupDynamicYieldClientListeners() {
  const onDocumentLoaded = () => {
    dynamicYieldClient.updateHistoryState()
    dynamicYieldClient.trackUserComingFromEmail()
  }
  if (document.readyState == 'loading') {
    window.addEventListener('DOMContentLoaded', onDocumentLoaded)
  } else {
    onDocumentLoaded()
  }
  window.addEventListener('popstate', () => {
    dynamicYieldClient.updatePageContext(true)
  })
  EventBus.$on(EVENTS.minicart.update, e => {
    dynamicYieldClient.onCartUpdate(e)
  })
}
